import React, { useEffect } from 'react';
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Linking,
  Platform,
} from 'react-native';
import { useMediaQuery } from 'react-responsive';

import { DOCUMENT_TYPE } from 'shared/constants/ekyc';
import Button from 'shared/modules/common/components/atoms/Button';
import Icon from 'shared/modules/common/components/atoms/Icon';
import SimpleRadio from 'shared/modules/common/components/atoms/SimpleRadio';
import generateID from 'shared/modules/common/utils/generate-id';
type Props = {
  onNextButtonPress: () => void;
  selectedDocument: string;
  onFocus?: () => void;
  onBlur?: () => void;
  onDocumentSelect: (option: string) => void;
  onLiquidTermsButtonPress: () => void;
};
const HOUKATSU_URL = 'https://terms.paidy.com/hokatsu';

const PickDocument = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const {
    onNextButtonPress,
    selectedDocument,
    onDocumentSelect,
    onLiquidTermsButtonPress,
    onFocus,
    onBlur,
  } = props;

  useEffect(() => {
    onFocus?.();

    return () => onBlur?.();
  }, []);

  // Dynamic style of the option based on selection
  const getOptionViewStyle = (checked: boolean) => {
    if (checked) {
      return styles.optionViewSelected;
    } else {
      return styles.optionViewUnselected;
    }
  };

  return (
    <View style={styles.root}>
      <Text style={styles.mainTitle}>{`本人確認書類の選択`} </Text>

      <TouchableOpacity
        onPress={() => onDocumentSelect(DOCUMENT_TYPE.DRIVERS_LICENSE)}
        {...generateID('ekyc-pick-document-option-1')}
      >
        <View
          style={getOptionViewStyle(
            selectedDocument === DOCUMENT_TYPE.DRIVERS_LICENSE
          )}
        >
          <View style={styles.optionView}>
            <View style={styles.firstElementInRow}>
              <Icon
                name="drivers-license"
                size="24"
                style={{ marginRight: 9 }}
              />
              <Text style={styles.optionText}>{`運転免許証`}</Text>
            </View>
            <View style={styles.lastElementInRow}>
              <SimpleRadio
                checked={selectedDocument === DOCUMENT_TYPE.DRIVERS_LICENSE}
              />
            </View>
          </View>
        </View>
      </TouchableOpacity>

      <TouchableOpacity
        onPress={() => onDocumentSelect(DOCUMENT_TYPE.MY_NUMBER)}
        {...generateID('ekyc-pick-document-option-2')}
      >
        <View
          style={getOptionViewStyle(
            selectedDocument === DOCUMENT_TYPE.MY_NUMBER
          )}
        >
          <View style={styles.optionView}>
            <View style={styles.firstElementInRow}>
              <Icon
                name="my-number-card"
                size="24"
                style={{ marginRight: 9 }}
              />
              <Text style={styles.optionText}>{`マイナンバーカード`}</Text>
            </View>
            <View style={styles.lastElementInRow}>
              <SimpleRadio
                checked={selectedDocument === DOCUMENT_TYPE.MY_NUMBER}
              />
            </View>
          </View>
        </View>
      </TouchableOpacity>

      <View style={[styles.buttonContainer, isBigScreen && { paddingTop: 60 }]}>
        <View style={styles.TandCContainer}>
          <TouchableOpacity
            {...Platform.select({
              web: {
                accessibilityRole: 'link',
                href: HOUKATSU_URL,
                hrefAttrs: {
                  target: '_blank',
                },
              },
              default: {
                onPress() {
                  Linking.openURL(HOUKATSU_URL);
                },
              },
            })}
          >
            <Text style={styles.TandCText}>
              <Text style={styles.link}>ペイディプラス利用規約</Text>と
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={onLiquidTermsButtonPress}
            {...generateID('ekyc-pick-document-terms-button')}
          >
            <Text style={styles.TandCText}>
              <Text style={styles.link}>本人確認サービス利用規約</Text>{' '}
              に同意して
            </Text>
          </TouchableOpacity>
        </View>
        <Button
          variant="primary"
          title="次へ"
          onPress={onNextButtonPress}
          id="ekyc-pick-document-next-button"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 24,
    color: '#000',
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  optionViewSelected: {
    paddingHorizontal: 16,
    paddingVertical: 20,
    borderWidth: 1.5,
    borderColor: '#E30E80',
    borderRadius: 16,
    backgroundColor: '#fff',
    marginBottom: 24,
  },
  optionViewUnselected: {
    paddingHorizontal: 16,
    paddingVertical: 20,
    borderWidth: 1.5,
    borderColor: '#fff',
    borderRadius: 16,
    backgroundColor: '#fff',
    marginBottom: 24,
  },
  optionView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  firstElementInRow: {
    flexDirection: 'row',
    flex: 8,
    alignItems: 'center',
  },
  lastElementInRow: {
    flex: 5,
    alignItems: 'flex-end',
  },
  optionText: {
    fontSize: 13,
    fontWeight: '600',
  },
  TandCContainer: {
    width: '100%',
    textAlign: 'center',
    paddingBottom: 16,
  },
  TandCText: {
    fontWeight: '300',
    fontSize: 13,
  },
  link: {
    color: '#E52581',
    textDecorationLine: 'underline',
    fontWeight: '300',
    fontSize: 13,
  },
});

export default PickDocument;
